import Nullstack from 'nullstack';
export default function IconMicroscopeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-microscope-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 21h14"
  }), "   ", Nullstack.element("path", {
    d: "M6 18h2"
  }), "   ", Nullstack.element("path", {
    d: "M7 18v3"
  }), "   ", Nullstack.element("path", {
    d: "M10 10l-1 1l3 3l1 -1m2 -2l3 -3l-3 -3l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M10.5 12.5l-1.5 1.5"
  }), "   ", Nullstack.element("path", {
    d: "M17 3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M12 21a6 6 0 0 0 5.457 -3.505m.441 -3.599a5.996 5.996 0 0 0 -2.183 -3.608"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}